import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ChartsModule } from 'ng2-charts';

import { AnalyticsGraph } from './analytics-graph/anaytics-graph.component';
import { BarChartFilteredWidgetComponent } from './bar-chart-filtered-widget/bar-chart-filtered-widget.component';
import { BarChartWidgetComponent } from './bar-chart-widget/bar-chart-widget.component';
import { LineGraphWidgetComponent } from './line-graph-widget/line-graph-widget.component';
import { MultiTableWidgetComponent } from './multi-table-widget/multi-table-widget.component';
import { TableWidgetComponent } from './table-widget/table-widget.component';
import { TotalActiveTimeWidgetComponent } from './total-active-time-widget/total-active-time-widget.component';
import { TransitionGraphWidgetComponent } from './transition-graph-widget/transition-graph-widget.component';
import { UsersPeakDateWidgetComponent } from './users-peak-date-widget/users-peak-date-widget.component';
import { UsersPeakWidgetComponent } from './users-peak-widget/users-peak-widget.component';
import { UsersWidgetComponent } from './users-widget/users-widget.component';

@NgModule({
  imports: [CommonModule, RouterModule, NgbModule, ChartsModule, FormsModule, NgMultiSelectDropDownModule.forRoot(), FontAwesomeModule],
  declarations: [
    AnalyticsGraph,
    UsersWidgetComponent,
    UsersPeakWidgetComponent,
    UsersPeakDateWidgetComponent,
    TotalActiveTimeWidgetComponent,
    LineGraphWidgetComponent,
    BarChartWidgetComponent,
    BarChartFilteredWidgetComponent,
    MultiTableWidgetComponent,
    TableWidgetComponent,
    TransitionGraphWidgetComponent
  ],
  exports: [
    AnalyticsGraph,
    UsersWidgetComponent,
    UsersPeakWidgetComponent,
    UsersPeakDateWidgetComponent,
    TotalActiveTimeWidgetComponent,
    MultiTableWidgetComponent,
    TableWidgetComponent,
    ChartsModule
  ]
})
export class HomeWidgetsModule {}
